export enum AvatarGraphQLActionType {
  createEmployeeAvatar = 'createEmployeeAvatar',
  updateEmployeeAvatar = 'updateEmployeeAvatar',
  removeEmployeeAvatar = 'removeEmployeeAvatar'
}
